import { DensityMode, SpacingMapping } from '../types/density';

// Comprehensive spacing mappings for different density modes
export const spacingMappings: SpacingMapping = {
  // Padding classes
  'p-0': { compact: 'p-0', normal: 'p-0', spacious: 'p-0' },
  'p-1': { compact: 'p-0.5', normal: 'p-1', spacious: 'p-1.5' },
  'p-2': { compact: 'p-1', normal: 'p-2', spacious: 'p-2.5' },
  'p-3': { compact: 'p-1.5', normal: 'p-3', spacious: 'p-4' },
  'p-4': { compact: 'p-2', normal: 'p-4', spacious: 'p-5' },
  'p-5': { compact: 'p-2.5', normal: 'p-5', spacious: 'p-6' },
  'p-6': { compact: 'p-3', normal: 'p-6', spacious: 'p-8' },
  'p-8': { compact: 'p-4', normal: 'p-8', spacious: 'p-10' },
  'p-10': { compact: 'p-5', normal: 'p-10', spacious: 'p-12' },
  'p-12': { compact: 'p-6', normal: 'p-12', spacious: 'p-16' },

  // X-axis padding
  'px-2': { compact: 'px-1', normal: 'px-2', spacious: 'px-2.5' },
  'px-3': { compact: 'px-1.5', normal: 'px-3', spacious: 'px-4' },
  'px-4': { compact: 'px-2', normal: 'px-4', spacious: 'px-5' },
  'px-6': { compact: 'px-3', normal: 'px-6', spacious: 'px-8' },
  'px-8': { compact: 'px-4', normal: 'px-8', spacious: 'px-10' },

  // Y-axis padding
  'py-2': { compact: 'py-1', normal: 'py-2', spacious: 'py-2.5' },
  'py-3': { compact: 'py-1.5', normal: 'py-3', spacious: 'py-4' },
  'py-4': { compact: 'py-2', normal: 'py-4', spacious: 'py-5' },
  'py-6': { compact: 'py-3', normal: 'py-6', spacious: 'py-8' },
  'py-8': { compact: 'py-4', normal: 'py-8', spacious: 'py-10' },

  // Margins
  'm-2': { compact: 'm-1', normal: 'm-2', spacious: 'm-2.5' },
  'm-3': { compact: 'm-1.5', normal: 'm-3', spacious: 'm-4' },
  'm-4': { compact: 'm-2', normal: 'm-4', spacious: 'm-5' },
  'm-6': { compact: 'm-3', normal: 'm-6', spacious: 'm-8' },
  'm-8': { compact: 'm-4', normal: 'm-8', spacious: 'm-10' },

  // X-axis margins
  'mx-2': { compact: 'mx-1', normal: 'mx-2', spacious: 'mx-2.5' },
  'mx-4': { compact: 'mx-2', normal: 'mx-4', spacious: 'mx-5' },
  'mx-6': { compact: 'mx-3', normal: 'mx-6', spacious: 'mx-8' },
  'mx-8': { compact: 'mx-4', normal: 'mx-8', spacious: 'mx-10' },
  'mx-auto': { compact: 'mx-auto', normal: 'mx-auto', spacious: 'mx-auto' },

  // Y-axis margins
  'my-2': { compact: 'my-1', normal: 'my-2', spacious: 'my-2.5' },
  'my-4': { compact: 'my-2', normal: 'my-4', spacious: 'my-5' },
  'my-6': { compact: 'my-3', normal: 'my-6', spacious: 'my-8' },
  'my-8': { compact: 'my-4', normal: 'my-8', spacious: 'my-10' },

  // Spacing (space-y, space-x)
  'space-y-2': { compact: 'space-y-1', normal: 'space-y-2', spacious: 'space-y-2.5' },
  'space-y-3': { compact: 'space-y-1.5', normal: 'space-y-3', spacious: 'space-y-4' },
  'space-y-4': { compact: 'space-y-2', normal: 'space-y-4', spacious: 'space-y-5' },
  'space-y-6': { compact: 'space-y-3', normal: 'space-y-6', spacious: 'space-y-8' },
  'space-y-8': { compact: 'space-y-4', normal: 'space-y-8', spacious: 'space-y-10' },

  'space-x-2': { compact: 'space-x-1', normal: 'space-x-2', spacious: 'space-x-2.5' },
  'space-x-3': { compact: 'space-x-1.5', normal: 'space-x-3', spacious: 'space-x-4' },
  'space-x-4': { compact: 'space-x-2', normal: 'space-x-4', spacious: 'space-x-5' },
  'space-x-6': { compact: 'space-x-3', normal: 'space-x-6', spacious: 'space-x-8' },

  // Gap classes
  'gap-2': { compact: 'gap-1', normal: 'gap-2', spacious: 'gap-2.5' },
  'gap-3': { compact: 'gap-1.5', normal: 'gap-3', spacious: 'gap-4' },
  'gap-4': { compact: 'gap-2', normal: 'gap-4', spacious: 'gap-5' },
  'gap-6': { compact: 'gap-3', normal: 'gap-6', spacious: 'gap-8' },
  'gap-8': { compact: 'gap-4', normal: 'gap-8', spacious: 'gap-10' },

  // Height classes for buttons and form elements
  'h-8': { compact: 'h-7', normal: 'h-8', spacious: 'h-9' },
  'h-10': { compact: 'h-8', normal: 'h-10', spacious: 'h-12' },
  'h-12': { compact: 'h-10', normal: 'h-12', spacious: 'h-14' },
  'h-16': { compact: 'h-12', normal: 'h-16', spacious: 'h-20' },

  // Font sizes
  'text-xs': { compact: 'text-xs', normal: 'text-xs', spacious: 'text-sm' },
  'text-sm': { compact: 'text-xs', normal: 'text-sm', spacious: 'text-base' },
  'text-base': { compact: 'text-sm', normal: 'text-base', spacious: 'text-lg' },
  'text-lg': { compact: 'text-base', normal: 'text-lg', spacious: 'text-xl' },
  'text-xl': { compact: 'text-lg', normal: 'text-xl', spacious: 'text-2xl' },

  // Responsive variants (sm:, md:, lg:)
  'sm:p-6': { compact: 'sm:p-3', normal: 'sm:p-6', spacious: 'sm:p-8' },
  'md:p-8': { compact: 'md:p-4', normal: 'md:p-8', spacious: 'md:p-10' },
  'lg:p-10': { compact: 'lg:p-5', normal: 'lg:p-10', spacious: 'lg:p-12' },

  'sm:px-6': { compact: 'sm:px-3', normal: 'sm:px-6', spacious: 'sm:px-8' },
  'md:px-8': { compact: 'md:px-4', normal: 'md:px-8', spacious: 'md:px-10' },
  'lg:px-12': { compact: 'lg:px-6', normal: 'lg:px-12', spacious: 'lg:px-16' },

  'sm:py-4': { compact: 'sm:py-2', normal: 'sm:py-4', spacious: 'sm:py-5' },
  'md:py-6': { compact: 'md:py-3', normal: 'md:py-6', spacious: 'md:py-8' },
  'lg:py-8': { compact: 'lg:py-4', normal: 'lg:py-8', spacious: 'lg:py-10' },
};

// Max-width adjustments for different densities
export const maxWidthMappings: SpacingMapping = {
  'max-w-sm': { compact: 'max-w-sm', normal: 'max-w-sm', spacious: 'max-w-md' },
  'max-w-md': { compact: 'max-w-sm', normal: 'max-w-md', spacious: 'max-w-lg' },
  'max-w-lg': { compact: 'max-w-md', normal: 'max-w-lg', spacious: 'max-w-xl' },
  'max-w-xl': { compact: 'max-w-lg', normal: 'max-w-xl', spacious: 'max-w-2xl' },
  'max-w-2xl': { compact: 'max-w-xl', normal: 'max-w-2xl', spacious: 'max-w-3xl' },
  'max-w-3xl': { compact: 'max-w-2xl', normal: 'max-w-3xl', spacious: 'max-w-4xl' },
  'max-w-4xl': { compact: 'max-w-3xl', normal: 'max-w-4xl', spacious: 'max-w-5xl' },
  'max-w-5xl': { compact: 'max-w-4xl', normal: 'max-w-5xl', spacious: 'max-w-6xl' },
  'max-w-6xl': { compact: 'max-w-5xl', normal: 'max-w-6xl', spacious: 'max-w-7xl' },
  'max-w-7xl': { compact: 'max-w-6xl', normal: 'max-w-7xl', spacious: 'max-w-7xl' },
};

/**
 * Convert a Tailwind CSS class to its density-aware equivalent
 */
export function convertTailwindClass(
  className: string,
  density: DensityMode,
  _type?: 'padding' | 'margin' | 'spacing' | 'gap' | 'height' | 'font' | 'maxwidth'
): string {
  // Check spacing mappings first
  const spacingMapping = spacingMappings[className];
  if (spacingMapping) {
    return spacingMapping[density];
  }

  // Check max-width mappings
  const maxWidthMapping = maxWidthMappings[className];
  if (maxWidthMapping) {
    return maxWidthMapping[density];
  }

  // If no mapping found, return original class
  return className;
}

/**
 * Convert multiple Tailwind classes in a string
 */
export function convertTailwindClasses(classNames: string, density: DensityMode): string {
  return classNames
    .split(' ')
    .map((className) => convertTailwindClass(className.trim(), density))
    .join(' ');
}

/**
 * Generate density-aware padding classes
 */
export function getDensityPadding(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'padding');
}

/**
 * Generate density-aware margin classes
 */
export function getDensityMargin(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'margin');
}

/**
 * Generate density-aware spacing classes (space-x, space-y)
 */
export function getDensitySpacing(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'spacing');
}

/**
 * Generate density-aware gap classes
 */
export function getDensityGap(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'gap');
}

/**
 * Generate density-aware height classes
 */
export function getDensityHeight(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'height');
}

/**
 * Generate density-aware font size classes
 */
export function getDensityFontSize(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'font');
}

/**
 * Generate density-aware max-width classes
 */
export function getDensityMaxWidth(baseClass: string, density: DensityMode): string {
  return convertTailwindClass(baseClass, density, 'maxwidth');
}

/**
 * Utility to create a complete density-aware className string
 */
export function createDensityAwareClasses(
  baseClasses: string,
  density: DensityMode,
  additionalClasses?: string
): string {
  const convertedClasses = convertTailwindClasses(baseClasses, density);
  return additionalClasses ? `${convertedClasses} ${additionalClasses}` : convertedClasses;
}

/**
 * Get density multipliers for custom calculations
 */
export function getDensityMultipliers(density: DensityMode) {
  const multipliers = {
    compact: {
      padding: 0.5,
      margin: 0.5,
      spacing: 0.5,
      fontSize: 0.875,
      lineHeight: 0.9,
    },
    normal: {
      padding: 1,
      margin: 1,
      spacing: 1,
      fontSize: 1,
      lineHeight: 1,
    },
    spacious: {
      padding: 1.25,
      margin: 1.25,
      spacing: 1.25,
      fontSize: 1.125,
      lineHeight: 1.1,
    },
  };

  return multipliers[density];
}

/**
 * Auto-detect optimal density mode based on screen size
 */
export function autoDetectDensityMode(): DensityMode {
  if (typeof window === 'undefined') return 'normal';

  const screenWidth = window.innerWidth;

  // Breakpoints based on common screen sizes
  if (screenWidth < 1400) return 'compact'; // Laptops and smaller screens
  if (screenWidth < 1920) return 'normal'; // Standard monitors
  return 'spacious'; // Large monitors and ultra-wide
}

/**
 * Responsive density class generator based on screen size
 */
export function getResponsiveDensityClasses(
  baseClasses: string,
  options?: {
    compactBreakpoint?: number;
    normalBreakpoint?: number;
    forceMode?: DensityMode;
  }
): string {
  if (options?.forceMode) {
    return convertTailwindClasses(baseClasses, options.forceMode);
  }

  const compactClasses = convertTailwindClasses(baseClasses, 'compact');
  const normalClasses = convertTailwindClasses(baseClasses, 'normal');
  const spaciousClasses = convertTailwindClasses(baseClasses, 'spacious');

  // Generate responsive variants
  return [
    compactClasses, // Default (mobile-first)
    `lg:${normalClasses.split(' ').join(' lg:')}`, // Large screens
    `xl:${spaciousClasses.split(' ').join(' xl:')}`, // Extra large screens
  ].join(' ');
}
